import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';

export const buildRichTextLink = url => ({
  nodeType: 'paragraph',
  content: [
    { nodeType: 'text', value: '', marks: [], data: {} },
    {
      nodeType: 'hyperlink',
      content: [
        { nodeType: 'text', value: 'Read Full Article', marks: [], data: {} },
      ],
      data: { uri: url },
    },
    { nodeType: 'text', value: '', marks: [], data: {} },
  ],
  data: {},
});

export const getBlogType = data => {
  const hasEditor = !_isEmpty(_get(data, 'editors.0.fields'));
  const hasPerson = !_isEmpty(_get(data, 'person.0.fields'));
  let blogType;
  if ((hasPerson && hasEditor) || hasPerson) {
    blogType = 'guest';
  } else if (hasEditor) {
    blogType = 'cm';
  }
  return blogType;
};
